import { createContext, useContext } from 'react';

// This context allows TimeStreamSearchResult to use the position
// from the canvas without requiring a direct import of the entire canvas package.
const GetCanvasPanZoomBounds = createContext<
    () => {
        bounds: { top: number; left: number; right: number; width: number; height: number };
        pan: { x: number; y: number };
        zoom: number;
    }
>(() => {
    return {
        bounds: { top: 0, left: 0, right: 0, width: 0, height: 0 },
        pan: { x: 0, y: 0 },
        zoom: 1,
    };
});
GetCanvasPanZoomBounds.displayName = 'GetCanvasPanZoomBounds';

/** Provider of the getCanvasPanZoomBounds function. Must be used by the canvas to inject the actual getCanvasPanZoomBounds function. */
export default GetCanvasPanZoomBounds.Provider;

/** Returns the function that provides the zoom level of the canvas. */
export function useGetCanvasPanZoomBounds() {
    return useContext(GetCanvasPanZoomBounds);
}
